import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';

const API = axios.create({ baseURL: '/api', withCredentials: true });

const CustomerSelect = () => {
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(true);
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    API.get('/customers').then(res => {
      setCustomers(res.data.filter(c => c.is_active));
      setLoading(false);
    }).catch(() => setLoading(false));
  }, []);

  const handleSelect = (customer) => {
  localStorage.setItem('selected_customer', JSON.stringify(customer));
  navigate('/dashboard', { replace: true });
};

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  return (
    <div className="page-container" style={{ alignItems: 'flex-start', paddingTop: '60px' }}>
      <div style={{ width: '100%', maxWidth: '600px' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '32px' }}>
          <div>
            <h1 style={{ fontSize: '28px', fontWeight: '600', color: 'white' }}>FCC Billing</h1>
            <p style={{ color: 'rgba(255,255,255,0.8)', marginTop: '4px' }}>Select a customer to continue</p>
          </div>
          <button className="btn btn-primary" style={{ width: 'auto', padding: '8px 16px' }} onClick={handleLogout}>
            Sign out
          </button>
        </div>

        {loading ? (
          <p style={{ color: 'rgba(255,255,255,0.8)' }}>Loading customers...</p>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
            {customers.map(customer => (
              <div
                key={customer.customer_id}
                onClick={() => handleSelect(customer)}
                style={{
                  background: 'white',
                  border: '1px solid #E2E8F0',
                  borderRadius: '8px',
                  padding: '20px 24px',
                  cursor: 'pointer',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  transition: 'all 0.15s'
                }}
                onMouseEnter={e => e.currentTarget.style.borderColor = '#F5A800'}
                onMouseLeave={e => e.currentTarget.style.borderColor = '#E2E8F0'}
              >
                <div>
                  <p style={{ fontWeight: '600', fontSize: '16px' }}>{customer.name}</p>
                  <p style={{ color: '#5B6B7F', fontSize: '13px', marginTop: '2px' }}>
                    Agent #{customer.agent_number}
                  </p>
                </div>
                <span style={{ color: '#F5A800', fontSize: '20px' }}>→</span>
              </div>
            ))}
            {(user?.role === 'boss' || user?.role === 'admin') && (
              <div
                onClick={() => navigate('/admin/customers')}
                style={{
                  background: '#FDF4DD',
                  border: '1px dashed #F2D89A',
                  borderRadius: '8px',
                  padding: '20px 24px',
                  cursor: 'pointer',
                  textAlign: 'center',
                  color: '#F5A800',
                  fontWeight: '500'
                }}
              >
                + Manage customers
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default CustomerSelect;